import { Loading ,Message } from 'element-ui';
import router from '@/router/index'
import axios from 'axios'
import ZMYDataCollection from "./zmy-data-collection-3.0.0.min"

//活动/直播端外 H5 日活统计
export function openActivityH5(id,url){
  // 省宣测试统计
  // ZMYDataCollection.init ({
  //   tenant_code: 'ff900bbef24b48748f5ab4685c4c92db',
  //   domain:"testrmapi.nfzmy.com",
  //   key: 'xY0rB2pH6uW9nG2sY5yE0jR3yP5mP0wM'
  // });
  //省宣正式统计
  ZMYDataCollection.init ({
    tenant_code: 'prod-dgrb-b541b88a633dc950e75870',
    domain:"rmapi.nfzmy.com",
    key: '6gKcrFJNMUgdNtKe8QODo7swl5lyibei'
  });
  ZMYDataCollection.openActivityH5({
    activity_id: id,
    platform: '招考通H5端',
    url:url
  });
}

//loading
export const loading = {
  loadingInstance: null, 
  // 加载loading
  open: function () {
    if (this.loadingInstance === null) {
      this.loadingInstance = Loading.service({
        target: '.main',
        text: '拼命加载中'
      });
    }
  },
  // 关闭loading
  close: function () {
    if (this.loadingInstance !== null) {
      this.loadingInstance.close();
    }
    this.loadingInstance = null;
  }
}
// 判断时间大于delayTime才显示loading
export const timeLoding = {
  requestCount:0,
  requestTimeIdList:[],
  delayTime:500,
  open(config){
    this.requestCount++;
    const timeId = setTimeout(() => {
      loading.open();
    },this.delayTime);
    this.requestTimeIdList.push({
      timeId: timeId,
      url: config.url
    });
  },
  close(url){
    this.requestCount--
    this.clearTimeoutByUrl(url, this.requestTimeIdList);
    if (this.requestCount <= 0) {
      loading.close();
    }
  },
  reset(){
    this.requestCount--
    this.resetTimeoutByUrl()
    if (this.requestCount <= 0) {
      loading.close();
    }
  },
  clearTimeoutByUrl(url,requestList){
    requestList.forEach((item,index)=>{
      if(item.url ===url){
        clearTimeout(item['timeId']);
        this.requestTimeIdzxList = requestList.splice(index,1)
      }
    })
  },
  resetTimeoutByUrl(){
    this.requestTimeIdList.forEach((timeItem,index) => {
      clearTimeout(this.requestTimeIdList[index]['timeId']);
    });
    this.requestTimeIdList = []
  },
}

//优先返回上一页
export function topPreviousPage(openType,year){
  if(window.history.length>1){
    window.history.go(-1);
  }else{
    router.push({name:'comEduHome',query:{year,openType}})
  }
}

//ios刷新
export function iosRefresh(){
  let agent = navigator.userAgent
  let isIOS = !!agent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
  if(isIOS && !sessionStorage.getItem('isShareState')){
    sessionStorage.setItem('isShareState',true)
    router.go(0)
  }
}
//动态设置title
export function setDocumentTitle (title) {
  document.title = title; 
  if (/ip(hone|od|ad)/i.test(navigator.userAgent)) { 
    var i = document.createElement('iframe'); 
    i.src = '/favicon.ico'; 
    i.style.display = 'none'; 
    i.onload = function() { 
      setTimeout(function(){ 
        i.remove(); 
      }, 9) 
    } 
    document.body.appendChild(i); 
  } }


//电话号码
export function handleTel(data){
  let result = data[0]+data[1]
  if(data[2]!==""){
    result = result+","+data[2]
  }
  return result
}
//处理电话格式
export function handlerPhone(data){
  const phoneList =  JSON.parse(data).map((subArray,index) =>({
    name:subArray.filter((item) => item !== "").join("-"),
    telUrl:handleTel(subArray)
  }));
  return phoneList
}

//选中电话号码
export function selectPhone(url) {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  const phoneNumber = url;
  var callLink = document.createElement("a"); // 创建一个新的<a>元素
  callLink.href =(isIOS? "tel://":"tel:") + phoneNumber; // 设置href属性为tel:加电话号码
  document.body.appendChild(callLink); // 将<a>元素添加到页面中
  callLink.click(); // 模拟点击<a>元素
  document.body.removeChild(callLink); // 移除<a>元素，保持页面干净
}

//初始化JSSDK数据
export  function  initJSSDK(){
  return new Promise(async (resolve,reject)=>{
    const url = location.href.split('#')[0]
    // const url = "http://z.timedg.com/2023/dgrb-zkt-code/H5/"
    axios({
      method: 'get',
      url: "https://api01.timedg.com/project/2018/weixin-jssdk-proxy/api.php",
      params:{
        r:"weixin/jssdk/ConfigFromSN",
        snappid:3,
        url:url
      },
      withCredentials: true, // 允许跨域携带cookie
      crossDomain: true, // 表示允许跨域请求
    }).then((res) => {
      const data = res.data
        if(data.code === 0){
          let config = data.rst
          // config.debug = true
          config.jsApiList = [
          "updateAppMessageShareData",
          "updateTimelineShareData",
          'onMenuShareTimeline', // 分享到朋友圈接口
          'onMenuShareAppMessage', //  分享到朋友接口
          'onMenuShareQQ', // 分享到QQ接口
          'onMenuShareQZone', // 分享到QQ空间
          'onMenuShareWeibo' // 分享到微博接口
          ],
          wx.config(config);
          wx.error((err) => {
            reject(err)
          });
          wx.ready(()=> {
            resolve()
          });
          return 
        }
        Message.error(data.err)
    });
  })
}
//初始化分享配置
/**
 * 
 * @param {
  * imgUrl,//图片地址
  * link,  //图片地址链接
  * title, //标题
  * desc,  //描述
* } config 
*/
//初始化分享配置
export const initSharkConfig = async(config)=>{
  iosRefresh()  
  await initJSSDK()
  const params = {
    imgUrl:"https://z.timedg.com/2023/dgrb-zkt-code/H5/defaultSharkimg.png",
    title:document.title,
    link:"https://z.timedg.com/2023/dgrb-zkt-code/H5/#"+ location.href.split('#')[1],
    desc:"招招领先 东莞招考通 东莞教育招生资讯平台",
    ...config
  }
  const shareData = {
    ...params,
    success : function() {
      console.log("分享成功")
    },
    cancel : function() {
      console.log("分享失败")
    }
  };
  wx.onMenuShareTimeline(shareData);
  wx.onMenuShareAppMessage(shareData);
  wx.onMenuShareQQ(shareData);
  wx.onMenuShareQZone(shareData);
  wx.onMenuShareWeibo(shareData);
}



// 对象转formData的文件数据格式
export function getFormData(object) {
  const formData = new FormData();
  Object.keys(object).forEach(key => {
    const value = object[key];
    if (Array.isArray(value)) {
      value.forEach((subValue, i) => {
        formData.append(key + `[${i}]`, subValue)
      })
    } else {
      formData.append(key, object[key])
    }
  })
  return formData;
}

//给数字切换单位
export function cutNum(num,s,step,unit){
  s = s || 0;
  step = step || 10000;
  if(Math.abs(num) >= step){
      return cutNum(num/step,s+1,step,unit);
  }
  let relUnit = unit || ['','万','亿','万亿','兆','京','垓','杼'];
  return relUnit[s]!==''?num.toFixed(2)+relUnit[s]:num
}

export function replaceBr(text){
  if(!text) return 
  return text.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>').replace(/\s/g, '&nbsp;')
}
//校验电话号码
export function verifyTel(tel){
  return /^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(Tel);
}

export function verifyEmile(emile){
  return /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/.test(emile);
}


//校验身份证
export function checkIdcard(value) {
  let message  = ""
  var sId = value;
  if (sId.length == 15) {
    if(!/^\d{14}(\d|x)$/i.test(sId)){
      message =  "你输入的身份证长度或格式错误";
      return false;
    } else  {
        sId=sId.substr(0,6)+'19'+sId.substr(6,9);
        sId+= getVCode(sId);
    }
  }
  function getVCode(CardNo17) {
    var Wi = new Array(7,9,10,5,8,4,2,1,6,3,7,9,10,5,8,4,2,1);
    var Ai = new Array('1','0','X','9','8','7','6','5','4','3','2');
    var cardNoSum = 0;
    for (var i=0; i<CardNo17.length; i++)cardNoSum+=CardNo17.charAt(i)*Wi[i];
    var seq = cardNoSum%11;
    return Ai[seq];
  }
  var aCity={11:"北京",12:"天津",13:"河北",14:"山西",15:"内蒙古",21:"辽宁",22:"吉林",23:"黑龙江",31:"上海",32:"江苏",33:"浙江",34:"安徽",35:"福建",36:"江西",37:"山东",41:"河南",42:"湖北",43:"湖南",44:"广东",45:"广西",46:"海南",50:"重庆",51:"四川",52:"贵州",53:"云南",54:"西藏",61:"陕西",62:"甘肃",63:"青海",64:"宁夏",65:"新疆",71:"台湾",81:"香港",82:"澳门",91:"国外"} ;

  var iSum=0 ;
  var info="" ;
  if(!/^\d{17}(\d|x)$/i.test(sId)){
    message =  "你输入的身份证长度或格式错误";
    return false;
  }
  sId=sId.replace(/x$/i,"a"); 
  if(aCity[parseInt(sId.substr(0,2))]==null){ 
    message =  "你的身份证地区非法";
    return false;
  }
  var sBirthday=sId.substr(6,4)+"-"+Number(sId.substr(10,2))+"-"+Number(sId.substr(12,2)); 
  var d=new Date(sBirthday.replace(/-/g,"/")) ;
  if(sBirthday!=(d.getFullYear()+"-"+ (d.getMonth()+1) + "-" + d.getDate())){
    message =  "身份证上的出生日期非法";
    return false; 
  }
  for(var i = 17;i>=0;i --) iSum += (Math.pow(2,i) % 11) * parseInt(sId.charAt(17 - i),11) ;
  if(iSum%11!=1){
    message =  "你输入的身份证号非法";
    return false; 
  }
  return true;
}

//获取保存的Cookie中的密码
export function getCookie() {
  let  echoAccount = {}
  if (document.cookie.length > 0) {
    var arr = document.cookie.split('; ')
    for (var i = 0; i < arr.length; i++) {
      var arr2 = arr[i].split('=') // 再次切割
      if (arr2[0] === 'userName') {
        echoAccount[arr2[0]] = arr2[1]
      } else if (arr2[0] === 'passWord') {
        echoAccount[arr2[0]] = arr2[1]
      }
    }
    return  echoAccount
  }
}

//密码和账号设置在cookike中
export function setCookie(name, pwd, exdays) {
  var exdate = new Date()
  exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays)
  window.document.cookie =
    'userName' + '=' + name + ';path=/;expires=' + exdate.toGMTString()
  window.document.cookie =
    'passWord' + '=' + pwd + ';path=/;expires=' + exdate.toGMTString()
}

export function clearCookie(name) {  
  setCookie(name, "", -1);  
}  

//本地图片转bin二进制文件
export function imageUrlToFile(imageUrl) {
  let image = new Image()
  image.setAttribute('crossOrigin', 'anonymous') // 解决跨域问题
  image.src = imageUrl // 如果是本地图片替换为 image.src = imageUrl
  return new Promise((resolve, reject) => {
    image.onload = () => {
      var canvas = document.createElement("canvas")
      canvas.width = image.width
      canvas.height = image.height
      var context = canvas.getContext('2d')
      context.drawImage(image, 0, 0, image.width, image.height)
      var quality = 0.8
      var dataURL = canvas.toDataURL("image/jpeg", quality) // 使用toDataUrl将图片转换成jpeg的格式,不要把图片压缩成png，因为压缩成png后base64的字符串可能比不转换前的长！
      const file = base64toFile(dataURL)
      resolve(file)
    }
  })
}

//将颜色值转为rgba
export function colorRgb(color,opacity){
  var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
  var sColor = color.toLowerCase();
  if(sColor && reg.test(sColor)){
    if(sColor.length === 4){
    var sColorNew = "#";
    for(var i=1; i<4; i+=1){
      sColorNew += sColor.slice(i,i+1).concat(sColor.slice(i,i+1));
    }
    sColor = sColorNew;
    }
    //处理六位的颜色值
    var sColorChange = [];
    for(var i=1; i<7; i+=2){
    sColorChange.push(parseInt("0x"+sColor.slice(i,i+2)));
    }
    if (opacity!== undefined){
    return "rgba(" + sColorChange.join(",") +','+opacity+ ")";
    }else{
    return "rgba(" + sColorChange.join(",") + ")";
    }
  }else{
    return sColor;
  }
}

export function base64toFile(dataurl, filename = 'file') {
  let arr = dataurl.split(',')
  let mime = arr[0].match(/:(.*?);/)[1]
  let suffix = mime.split('/')[1]
  let bstr = atob(arr[1])
  let n = bstr.length
  let u8arr = new Uint8Array(n)

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }

  let file = new File([u8arr], `${filename}.${suffix}`, {
    type: mime
  })
  return file
}

// tabel数据转excel
export function exportExcel(id) {
  //转换成excel时，使用原始的格式
  var xlsxParam = { raw: true };
  let fix = document.querySelector(".el-table__fixed");
  let wb;
  //判断有无fixed定位，如果有的话去掉，后面再加上，不然数据会重复
  if (fix) {
    wb = XLSX.utils.table_to_book(
      document.querySelector(id).removeChild(fix), xlsxParam);
    document.querySelector(id).appendChild(fix);
  } else {
    wb = XLSX.utils.table_to_book(document.querySelector(id), xlsxParam);
  }
  var wbout = XLSX.write(wb, {
    bookType: "xlsx",
    bookSST: true,
    type: "array",
  });
  try {
    FileSaver.saveAs(new Blob([wbout], { type: "application/octet-stream" }), "导出详情单.xlsx");
  } catch (e) {
    if (typeof console !== "undefined") console.log(e, wbout);
  }
  return wbout;
}



